import { createContext } from 'react';
import type { PublicUserResponse, SignupFormData } from '@/features/user/types/types';

export interface AuthContextType {
  // State
  user: PublicUserResponse | null;
  isAuthenticated: boolean;
  isGuest: boolean;
  isLoading: boolean;
  error: string | null;
  pendingSignupData: SignupFormData | null;
  isEmailVerified: boolean;
  
  // Actions
  setUser: (user: PublicUserResponse | null) => void;
  setError: (error: string | null) => void;
  clearError: () => void;
  setPendingSignupData: (data: SignupFormData | null) => void;
  setIsEmailVerified: (verified: boolean) => void;
  login: (user: PublicUserResponse) => void;
  logout: () => Promise<void>;
  refetch: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

